import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import ContactTable from "./ContactTable";
import CreateContactModal from "../create-contact/create-contact-modal";
import SearchHeader from "../../../components/search-header/search-header";
import { useAuth } from "../../../context/AuthContext";
import useContacts from "../../../hooks/useContacts";
import { generateContactsCSV } from "./csv/contacts-csv";


function ContactModal() {
  const { userPermissions } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [nextId, setNextId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const { contacts, isLoading, isError, refetch } = useContacts();

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const showHeaderCta =
    userPermissions === "Admin" ||
    userPermissions === "Project Manager" ||
    userPermissions === "Supervisor";

  return (
    <div className="company-container">
      <SearchHeader
        placeholder={"Search a keyword, client or contact."} 
        heading={"Contacts"}
        ctaTitle={showHeaderCta ? "Add Contact" : ""}
        ctaHandler={() => setShowModal(true)}
        handleSearch={handleSearch}
        optionsList={[
          { title: 'Export List CSV', onClick: () => generateContactsCSV(contacts) },
        ]}
      />
      {contacts && (
        <ContactTable 
          searchQuery={searchQuery} 
          handleShowModal={handleShowModal}
          contacts={contacts} />
      )}

      {showModal && (
        <CreateContactModal
          nextId={nextId}
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            refetch(); // Refetch companies to update the list
            setShowModal(false);
          }}
          isConfirming={false}
        />
      )}
    </div>
  );
}

export default ContactModal;
